var exports = {
  "kL": "x127c5a35--2cdc16--container",
  "yN": "x127c5a35--2cdc16--buttons_container",
  "mR": "x127c5a35--2cdc16--left_block",
};

module.exports = exports;
